// DO NOT EDIT THIS FILE!
// This file was generated by ubi-generators (https://ghe.spotify.net/datainfra/ubi-generators).
// For support, contact us on the #ubi-users Slack channel.
const SPECIFICATION_ID = "web-support-article";
const APP = "support-spotify-com";
const SPECIFICATION_VERSION = "8.0.0";
const SPECIFICATION_MODE = "default";
const GENERATOR_VERSION = "16.0.1";
/**
 * Creates an event factory to generate events
 * @params options - The required context for this specification
 *  - `option.data`: Required metadata for root parameters
 *  - {string} `option.data.identifier`: An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
 *  - {string} `option.data.uri`: A URI for the node required by the specification. This data is encrypted by default
 * @returns {WebSupportArticleEventFactory} A new instance of WebSupportArticleEventFactory
 */
export function createWebSupportArticleEventFactory(options) {
    return new WebSupportArticleEventFactory(options);
}
/**
 *
 */
export class WebSupportArticleEventFactory {
    constructor(options) {
        this._path = [{
                name: SPECIFICATION_ID,
                ...options.data
            }];
        if (options?.parentAbsoluteLocation) {
            this._parentAbsoluteLocation = options.parentAbsoluteLocation;
        }
    }
    /**
     * Creates a new instance of CategoryArticleContainerEventFactory
     * @param {Object} data - The required metadata for this element node.
     * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
     * @returns {CategoryArticleContainerEventFactory}  A new instance of CategoryArticleContainerEventFactory
     */
    categoryArticleContainerFactory(data) {
        return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data
        });
    }
    /**
     * Creates a new instance of CommunityLinkEventFactory
     * @returns {CommunityLinkEventFactory}  A new instance of CommunityLinkEventFactory
     */
    communityLinkFactory() {
        return new WebSupportArticleEventFactory.CommunityLinkEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    }
    _getCurrentLocation() {
        return {
            pathNodes: this._path,
            specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
            specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
        };
    }
    getAbsoluteLocation() {
        const parentLocations = this._parentAbsoluteLocation?.locations;
        return {
            locations: [
                ...(parentLocations || []),
                this._getCurrentLocation()
            ],
        };
    }
}
(function (WebSupportArticleEventFactory) {
    /**
     * Create CategoryArticleContainerEventFactory class with path
     * @param path to this node
     */
    class CategoryArticleContainerEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                ...data,
                name: "category_article_container"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
         * Creates a new instance of BreadcrumbsEventFactory
         * @returns {BreadcrumbsEventFactory}  A new instance of BreadcrumbsEventFactory
         */
        breadcrumbsFactory() {
            return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.BreadcrumbsEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation
            });
        }
        /**
         * Creates a new instance of ArticleContainerEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
         * @returns {ArticleContainerEventFactory}  A new instance of ArticleContainerEventFactory
         */
        articleContainerFactory(data) {
            return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleContainerEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        /**
         * Creates a new instance of RelatedArticleEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
         * @param {number} data.position- A position for the node required by the specification
         * @returns {RelatedArticleEventFactory}  A new instance of RelatedArticleEventFactory
         */
        relatedArticleFactory(data) {
            return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.RelatedArticleEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        /**
         * Creates a new instance of ArticleHelpfulContainerEventFactory
         * @returns {ArticleHelpfulContainerEventFactory}  A new instance of ArticleHelpfulContainerEventFactory
         */
        articleHelpfulContainerFactory() {
            return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation
            });
        }
        /**
         * Creates a new instance of ArticleCtaEventFactory
         * @param {Object} data - The required metadata for this element node.
         * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
         * @returns {ArticleCtaEventFactory}  A new instance of ArticleCtaEventFactory
         */
        articleCtaFactory(data) {
            return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleCtaEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data
            });
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
    }
    WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = CategoryArticleContainerEventFactory;
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    /**
     * Create CommunityLinkEventFactory class with path
     * @param path to this node
     */
    class CommunityLinkEventFactory {
        constructor({ path, parentAbsoluteLocation, data }) {
            this._path = path.concat({
                name: "community_link"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        _getCurrentLocation() {
            return {
                pathNodes: this._path,
                specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
            };
        }
        getAbsoluteLocation() {
            const parentLocations = this._parentAbsoluteLocation?.locations;
            return {
                locations: [
                    ...(parentLocations || []),
                    this._getCurrentLocation()
                ],
            };
        }
        /**
         * Create interaction for hit ui_navigate action.
       * @param destination the destination field
         */
        hitUiNavigate({ destination }) {
            const data = {
                actionParameterNames: ['destination'],
                actionParameterValues: [destination.toString()],
                actionName: "ui_navigate",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
        /**
         * Create impression for CommunityLinkEventFactory.
         */
        impression() {
            const data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        }
    }
    WebSupportArticleEventFactory.CommunityLinkEventFactory = CommunityLinkEventFactory;
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        /**
         * Create BreadcrumbsEventFactory class with path
         * @param path to this node
         */
        class BreadcrumbsEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    name: "breadcrumbs"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            /**
             * Creates a new instance of HomeLinkEventFactory
             * @returns {HomeLinkEventFactory}  A new instance of HomeLinkEventFactory
             */
            homeLinkFactory() {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.BreadcrumbsEventFactory.HomeLinkEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                });
            }
            /**
             * Creates a new instance of ParentCategoryBreadcrumbEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
             * @returns {ParentCategoryBreadcrumbEventFactory}  A new instance of ParentCategoryBreadcrumbEventFactory
             */
            parentCategoryBreadcrumbFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.BreadcrumbsEventFactory.ParentCategoryBreadcrumbEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
        }
        CategoryArticleContainerEventFactory.BreadcrumbsEventFactory = BreadcrumbsEventFactory;
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        /**
         * Create ArticleContainerEventFactory class with path
         * @param path to this node
         */
        class ArticleContainerEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "article_container"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            /**
             * Creates a new instance of VideoElementEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
             * @returns {VideoElementEventFactory}  A new instance of VideoElementEventFactory
             */
            videoElementFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleContainerEventFactory.VideoElementEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            /**
             * Creates a new instance of ArticleLinkEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
             * @returns {ArticleLinkEventFactory}  A new instance of ArticleLinkEventFactory
             */
            articleLinkFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleContainerEventFactory.ArticleLinkEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            /**
             * Creates a new instance of UrlLinkEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.uri- A URI for the node required by the specification. This data is encrypted by default
             * @returns {UrlLinkEventFactory}  A new instance of UrlLinkEventFactory
             */
            urlLinkFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleContainerEventFactory.UrlLinkEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            /**
             * Creates a new instance of AccordionEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {string} data.identifier- An id for the node required by the specification. Not encrypted and therefore not suitable for personal data or spotify URIs
             * @returns {AccordionEventFactory}  A new instance of AccordionEventFactory
             */
            accordionFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleContainerEventFactory.AccordionEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create impression for ArticleContainerEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CategoryArticleContainerEventFactory.ArticleContainerEventFactory = ArticleContainerEventFactory;
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        /**
         * Create RelatedArticleEventFactory class with path
         * @param path to this node
         */
        class RelatedArticleEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "related_article"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for RelatedArticleEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CategoryArticleContainerEventFactory.RelatedArticleEventFactory = RelatedArticleEventFactory;
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        /**
         * Create ArticleHelpfulContainerEventFactory class with path
         * @param path to this node
         */
        class ArticleHelpfulContainerEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    name: "article_helpful_container"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            /**
             * Creates a new instance of ArticleHelpfulYesButtonEventFactory
             * @returns {ArticleHelpfulYesButtonEventFactory}  A new instance of ArticleHelpfulYesButtonEventFactory
             */
            articleHelpfulYesButtonFactory() {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory.ArticleHelpfulYesButtonEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                });
            }
            /**
             * Creates a new instance of ArticleHelpfulNoButtonEventFactory
             * @returns {ArticleHelpfulNoButtonEventFactory}  A new instance of ArticleHelpfulNoButtonEventFactory
             */
            articleHelpfulNoButtonFactory() {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory.ArticleHelpfulNoButtonEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                });
            }
            /**
             * Creates a new instance of ArticleHelpfulSubmitFeedbackButtonEventFactory
             * @param {Object} data - The required metadata for this element node.
             * @param {broken_content|confusing|did_not_answer|did_not_work|other} data.identifier- why user thinks this article is not helpful
             * @returns {ArticleHelpfulSubmitFeedbackButtonEventFactory}  A new instance of ArticleHelpfulSubmitFeedbackButtonEventFactory
             */
            articleHelpfulSubmitFeedbackButtonFactory(data) {
                return new WebSupportArticleEventFactory.CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory.ArticleHelpfulSubmitFeedbackButtonEventFactory({
                    path: this._path,
                    parentAbsoluteLocation: this._parentAbsoluteLocation,
                    data
                });
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create impression for ArticleHelpfulContainerEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory = ArticleHelpfulContainerEventFactory;
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        /**
         * Create ArticleCtaEventFactory class with path
         * @param path to this node
         */
        class ArticleCtaEventFactory {
            constructor({ path, parentAbsoluteLocation, data }) {
                this._path = path.concat({
                    ...data,
                    name: "article_cta"
                });
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            _getCurrentLocation() {
                return {
                    pathNodes: this._path,
                    specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                    specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                };
            }
            getAbsoluteLocation() {
                const parentLocations = this._parentAbsoluteLocation?.locations;
                return {
                    locations: [
                        ...(parentLocations || []),
                        this._getCurrentLocation()
                    ],
                };
            }
            /**
             * Create interaction for hit ui_navigate action.
           * @param destination the destination field
             */
            hitUiNavigate({ destination }) {
                const data = {
                    actionParameterNames: ['destination'],
                    actionParameterValues: [destination.toString()],
                    actionName: "ui_navigate",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
            /**
             * Create impression for ArticleCtaEventFactory.
             */
            impression() {
                const data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            }
        }
        CategoryArticleContainerEventFactory.ArticleCtaEventFactory = ArticleCtaEventFactory;
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var BreadcrumbsEventFactory;
        (function (BreadcrumbsEventFactory) {
            /**
             * Create HomeLinkEventFactory class with path
             * @param path to this node
             */
            class HomeLinkEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        name: "home_link"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_navigate action.
               * @param destination the destination field
                 */
                hitUiNavigate({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "ui_navigate",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for HomeLinkEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            BreadcrumbsEventFactory.HomeLinkEventFactory = HomeLinkEventFactory;
        })(BreadcrumbsEventFactory = CategoryArticleContainerEventFactory.BreadcrumbsEventFactory || (CategoryArticleContainerEventFactory.BreadcrumbsEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var BreadcrumbsEventFactory;
        (function (BreadcrumbsEventFactory) {
            /**
             * Create ParentCategoryBreadcrumbEventFactory class with path
             * @param path to this node
             */
            class ParentCategoryBreadcrumbEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "parent_category_breadcrumb"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_navigate action.
               * @param destination the destination field
                 */
                hitUiNavigate({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "ui_navigate",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for ParentCategoryBreadcrumbEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            BreadcrumbsEventFactory.ParentCategoryBreadcrumbEventFactory = ParentCategoryBreadcrumbEventFactory;
        })(BreadcrumbsEventFactory = CategoryArticleContainerEventFactory.BreadcrumbsEventFactory || (CategoryArticleContainerEventFactory.BreadcrumbsEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleContainerEventFactory;
        (function (ArticleContainerEventFactory) {
            /**
             * Create VideoElementEventFactory class with path
             * @param path to this node
             */
            class VideoElementEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "video_element"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create impression for VideoElementEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleContainerEventFactory.VideoElementEventFactory = VideoElementEventFactory;
        })(ArticleContainerEventFactory = CategoryArticleContainerEventFactory.ArticleContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleContainerEventFactory;
        (function (ArticleContainerEventFactory) {
            /**
             * Create ArticleLinkEventFactory class with path
             * @param path to this node
             */
            class ArticleLinkEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "article_link"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_navigate action.
               * @param destination the destination field
                 */
                hitUiNavigate({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "ui_navigate",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for ArticleLinkEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleContainerEventFactory.ArticleLinkEventFactory = ArticleLinkEventFactory;
        })(ArticleContainerEventFactory = CategoryArticleContainerEventFactory.ArticleContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleContainerEventFactory;
        (function (ArticleContainerEventFactory) {
            /**
             * Create UrlLinkEventFactory class with path
             * @param path to this node
             */
            class UrlLinkEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "url_link"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_navigate action.
               * @param destination the destination field
                 */
                hitUiNavigate({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "ui_navigate",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create interaction for hit navigate_to_external_uri action.
               * @param destination the destination field
                 */
                hitNavigateToExternalUri({ destination }) {
                    const data = {
                        actionParameterNames: ['destination'],
                        actionParameterValues: [destination.toString()],
                        actionName: "navigate_to_external_uri",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for UrlLinkEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleContainerEventFactory.UrlLinkEventFactory = UrlLinkEventFactory;
        })(ArticleContainerEventFactory = CategoryArticleContainerEventFactory.ArticleContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleContainerEventFactory;
        (function (ArticleContainerEventFactory) {
            /**
             * Create AccordionEventFactory class with path
             * @param path to this node
             */
            class AccordionEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "accordion"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_reveal action.
                 */
                hitUiReveal() {
                    const data = {
                        actionName: "ui_reveal",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create interaction for hit ui_hide action.
                 */
                hitUiHide() {
                    const data = {
                        actionName: "ui_hide",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for AccordionEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleContainerEventFactory.AccordionEventFactory = AccordionEventFactory;
        })(ArticleContainerEventFactory = CategoryArticleContainerEventFactory.ArticleContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleHelpfulContainerEventFactory;
        (function (ArticleHelpfulContainerEventFactory) {
            /**
             * Create ArticleHelpfulYesButtonEventFactory class with path
             * @param path to this node
             */
            class ArticleHelpfulYesButtonEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        name: "article_helpful_yes_button"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_select action.
                 */
                hitUiSelect() {
                    const data = {
                        actionName: "ui_select",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleHelpfulContainerEventFactory.ArticleHelpfulYesButtonEventFactory = ArticleHelpfulYesButtonEventFactory;
        })(ArticleHelpfulContainerEventFactory = CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleHelpfulContainerEventFactory;
        (function (ArticleHelpfulContainerEventFactory) {
            /**
             * Create ArticleHelpfulNoButtonEventFactory class with path
             * @param path to this node
             */
            class ArticleHelpfulNoButtonEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        name: "article_helpful_no_button"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_select action.
                 */
                hitUiSelect() {
                    const data = {
                        actionName: "ui_select",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleHelpfulContainerEventFactory.ArticleHelpfulNoButtonEventFactory = ArticleHelpfulNoButtonEventFactory;
        })(ArticleHelpfulContainerEventFactory = CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
(function (WebSupportArticleEventFactory) {
    var CategoryArticleContainerEventFactory;
    (function (CategoryArticleContainerEventFactory) {
        var ArticleHelpfulContainerEventFactory;
        (function (ArticleHelpfulContainerEventFactory) {
            /**
             * Create ArticleHelpfulSubmitFeedbackButtonEventFactory class with path
             * @param path to this node
             */
            class ArticleHelpfulSubmitFeedbackButtonEventFactory {
                constructor({ path, parentAbsoluteLocation, data }) {
                    this._path = path.concat({
                        ...data,
                        name: "article_helpful_submit_feedback_button"
                    });
                    if (parentAbsoluteLocation) {
                        this._parentAbsoluteLocation = parentAbsoluteLocation;
                    }
                }
                _getCurrentLocation() {
                    return {
                        pathNodes: this._path,
                        specMode: [SPECIFICATION_MODE, ...[...Array(this._path.length - 1)].map(() => '')],
                        specVersion: [SPECIFICATION_VERSION, ...[...Array(this._path.length - 1)].map(() => '')]
                    };
                }
                getAbsoluteLocation() {
                    const parentLocations = this._parentAbsoluteLocation?.locations;
                    return {
                        locations: [
                            ...(parentLocations || []),
                            this._getCurrentLocation()
                        ],
                    };
                }
                /**
                 * Create interaction for hit ui_select action.
                 */
                hitUiSelect() {
                    const data = {
                        actionName: "ui_select",
                        actionVersion: 1,
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        interactionType: "hit",
                        specificationMode: SPECIFICATION_MODE,
                        specificationVersion: SPECIFICATION_VERSION,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
                /**
                 * Create impression for ArticleHelpfulSubmitFeedbackButtonEventFactory.
                 */
                impression() {
                    const data = {
                        app: APP,
                        generatorVersion: GENERATOR_VERSION,
                        specificationVersion: SPECIFICATION_VERSION,
                        specificationMode: SPECIFICATION_MODE,
                        annotatorConfigurationVersion: '',
                        annotatorVersion: '',
                        location: this._getCurrentLocation(),
                        parentAbsoluteLocation: this._parentAbsoluteLocation
                    };
                    return data;
                }
            }
            ArticleHelpfulSubmitFeedbackButtonEventFactory.Identifier = {
                BROKEN_CONTENT: "broken_content",
                CONFUSING: "confusing",
                DID_NOT_ANSWER: "did_not_answer",
                DID_NOT_WORK: "did_not_work",
                OTHER: "other",
            };
            ArticleHelpfulContainerEventFactory.ArticleHelpfulSubmitFeedbackButtonEventFactory = ArticleHelpfulSubmitFeedbackButtonEventFactory;
        })(ArticleHelpfulContainerEventFactory = CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory || (CategoryArticleContainerEventFactory.ArticleHelpfulContainerEventFactory = {}));
    })(CategoryArticleContainerEventFactory = WebSupportArticleEventFactory.CategoryArticleContainerEventFactory || (WebSupportArticleEventFactory.CategoryArticleContainerEventFactory = {}));
})(WebSupportArticleEventFactory || (WebSupportArticleEventFactory = {}));
